export * from './palettesFromComponentApi/getPalettesFromComponentApi';
export * from './palettesFromComponentApi/constants';
export * from './palettesFromComponentApi/types';
export * from './colors/consts';
